
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"38","height":"38","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('circle',{attrs:{"cx":"19","cy":"19","r":"19","fill":"#00A3FF"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M24.83 17.054h-1.172v-2.797c0-2.432-1.873-4.257-4.216-4.257-2.342 0-4.217 1.946-4.217 4.257v2.675h-1.053c-.705 0-1.172.607-1.172 1.216v8.636c0 .732.584 1.216 1.172 1.216H24.83c.703 0 1.17-.607 1.17-1.215v-8.638c0-.608-.468-1.093-1.17-1.093zm-4.686 6.57v1.338c0 .364-.233.607-.584.607-.352 0-.587-.242-.587-.607v-1.339c-.703-.243-1.17-.972-1.17-1.702 0-.973.819-1.825 1.755-1.825.938 0 1.758.852 1.758 1.825 0 .852-.586 1.46-1.172 1.704zm1.172-6.69l-3.63.121v-2.798c0-.973.82-1.825 1.756-1.825s1.757.852 1.757 1.825l.117 2.677z","fill":"#fff"}})])
          )
        }
      }
    